module.exports = __webpack_public_path__ + "static/media/RehabSeattingLogo-HZ6.0bb617c3.png";